import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import EditTable from '../EditTable';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';

class Shops extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			shops: [],
			editable: false,
			editorsOpen: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadShops();
	}

	loadShops() {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'SHOPS_VW',
				search: { Attribute: 'DELETE_FLAG', Operator: 'is null' },
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				for (var i = 0; i < data.Data.length; i++) {
					data.Data[i].id = i;
				}
				self.mergeState({ shops: data.Data });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState, accessor, value);

		// if this accessor represents an EditTable
		if (['shops'].includes(accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.mergeState(newState);
	}

	onSubmit(event) {
		var self = this;

		if (this.state.editorsOpen.includes('shops')) {
			this.showAlert('Editor Open', 'Please close the shop editor before saving.');
		} else {
			var shops = this.copyObject(this.state.shops);

			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/UpdateShops',
				overlay: true,
				data: {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					shops: {
						shops: shops
					}
				}
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Shops successfully updated.
						</>);
					});				
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							List of Shops&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
						<div style={{ marginBottom: '10px' }}>
							Before entering or modifying a recharge code, please check with the recharge analyst, the person who sets those codes.
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
						  data={this.state.shops} editable={this.state.editable} tableColumns={shopTableColumns} 
						  editColumns={shopEditColumns} tableName='Jobtrack_Shops' newRecord={emptyShop}
						  onEdit={(editorIsOpen, idx) => this.onEdit('shops', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('shops', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
						{this.state.editable && <Button id="save" variant="warning" type="button" className="float-end" onClick={() => this.onSubmit()}>Save</Button>}
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const emptyShop = {
	SHOP_ID: null,
	SHOP_NAME: '',
	SHOP_LOC: '',
	SHOP_RCHCODE: '',
	SHOP_MANAGER: null,
	DELETE_FLAG: null,
	SHOP_EMAIL: '',
	ACTIVE_FLAG: 'Y'
};

const shopTableColumns = [
	{ Header: 'ID', accessor: 'SHOP_ID', width: 60 },
	{ Header: 'Name', accessor: 'SHOP_NAME', width: 200 },
	{ Header: 'Location', accessor: 'SHOP_LOC', width: 200 },
	{ Header: 'Recharge Code', accessor: 'SHOP_RCHCODE', width: 80 },
	{ Header: 'Manager', accessor: 'SHOP_MANAGER_NAME', width: 200 },
	{ Header: 'Active', accessor: 'ACTIVE_FLAG', width: 60 }
];

const shopEditColumns = [
	{ Header: 'ID', accessor: 'SHOP_ID', row: 0, col: 0, editable: false },
	{ Header: 'Name', accessor: 'SHOP_NAME', row: 0, col: 1, required: true },
	{ Header: 'Location', accessor: 'SHOP_LOC', row: 1, col: 0 },
	{ Header: 'Recharge Code', accessor: 'SHOP_RCHCODE', row: 1, col: 1, required: true },
	{ Header: 'Manager', accessor: 'SHOP_MANAGER', labelAccessor: 'SHOP_MANAGER_NAME', type: 'select', row: 2, col: 0,
		options: { value: 'PERSON_ID', label: 'EMP_NAME', entity: 'RECHARGES.SHOP_MANAGER_SELECT_VW', order: 'EMP_NAME' }},
	{ Header: 'Active', accessor: 'ACTIVE_FLAG', type: 'checkbox', row: 2, col: 1 } 
];

export default withRouter(Shops);
